module.exports = __webpack_public_path__ + "media/images/mailers/right_arrow-d5690997e9c67551cedca2e1ce0dbc05.png";